import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { ClientTaskPage } from '../../../../../components/client/task-page';
import { clientReviewQuery } from '../../../../../lib/tasks-api';
import { buttonClassName } from '../../../../../components/ui/button';
import { PageSkeleton } from '../../../../../components/ui/skeleton';
import { LoadFailure } from '../../../../../components/ui/state-views';

export const Route = createFileRoute('/subdomain/app/_client/tasks/$taskId')({
  component: ClientTaskRoute,
});

const PAGE =
  'flex flex-col gap-(--mbm-space-6) px-(--mbm-space-4) py-(--mbm-space-6) lg:gap-(--mbm-space-7) lg:px-(--mbm-space-9) lg:pb-(--mbm-space-7) lg:pt-(--mbm-space-8)';

/** One of the client's tasks (Figma C03.3). */
function ClientTaskRoute() {
  const { taskId } = Route.useParams();
  const { data: review, isLoading, error, refetch } = useQuery({ ...clientReviewQuery(taskId), retry: false });

  if (isLoading) {
    return (
      <div className={PAGE}>
        <PageSkeleton label="Loading your task" />
      </div>
    );
  }

  return (
    <div className={PAGE}>
      {review ? (
        <ClientTaskPage review={review} />
      ) : (
        <LoadFailure
          error={error}
          noun="task"
          forbiddenHint="It isn’t one of yours."
          notFoundHint="It may have been removed, or it isn’t one of yours."
          className="rounded-(--mbm-component-radius-widget) bg-surface-card shadow-(--mbm-shadow-table-card)"
          action={
            <Link to="/subdomain/app/projects" search={{ q: undefined }} className={buttonClassName({ size: 'state' })}>
              Back to projects
            </Link>
          }
          onRetry={() => void refetch()}
        />
      )}
    </div>
  );
}
